import { ILayoutToolsAction } from '@base/@types/components/Layout/Tools'
import { IActionsHeaderKpi } from '@base/@types/providers/Kpi/StorageProvider'

export const actionsHeaderKpi = ({
  data,
  headers,
  toggleColumn,
  parseStorageKpiData
}: IActionsHeaderKpi) => {
  return [
    {
      type: 'export',
      exports: [
        {
          type: 'excel',
          entity: 'storangeKpi',
          data,
          headers,
          parser: parseStorageKpiData
        }
      ]
    },
    {
      type: 'columns',
      data: headers,
      onToggleColumn: toggleColumn
    }
  ] as ILayoutToolsAction[]
}
